import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Input } from "antd";

import { normalizeEmployeeStatus, renderStatus } from "../../utils/generalUtils";

import AdminTable from "../../components/Table/AdminTable/AdminTable";

import useEmployeeService from "../../services/PositionAdmin/employeeService";
import usePositionService from "../../services/PositionAdmin/positionService";
import PivotLoading from "../../components/Loading/PivotLoading";

const { Search } = Input;

const InactiveEmployees = () => {
  const { adminAddInactiveEmp } = useSelector((state) => state.generalSlice);

  const [searchValue, setSearchValue] = useState("");

  const {
    getAllEmployees,
    employeeLoading,
    employeeResponse,
    editEmployee,
    editEmployeeLoading,
  } = useEmployeeService();

  const { getAllPosition, positionLoading, positionResponse } =
    usePositionService();

  const handleRefresh = (search = "") => {
    getAllEmployees(search);
    getAllPosition();
  };

  useEffect(() => {
    handleRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (value) => {
    setSearchValue(value);
    handleRefresh(value);
  };

  const mappedPosData = positionResponse?.data?.map((item) => {
    const isDisabled = item?.is_active === false;
    return {
      value: item?.id,
      label: `${isDisabled ? "[Disabled] " : ""}${item?.position_name} - ${item?.unit}`,
      disabled: isDisabled,
    };
  });

  const mappedEmpData = (employeeResponse?.data || [])
    .map((item) => {
      const normalized = normalizeEmployeeStatus(item);
      return {
        key: 0,
        hasLoggedIn: item?.provider_id ? "yes" : "not yet",
        ...normalized,
      };
    })
    .filter((item) => !item.is_active)
    .map((item, index) => ({ ...item, key: index + 1 }));

  const activeStatusRenderer = renderStatus([], ["active"], ["inactive"], [], []);

  const adminEmpData = {
    employee: mappedEmpData ? [...mappedEmpData] : [],
    position: mappedPosData ? [...mappedPosData] : [],
  };

  const columns = [
    {
      title: "No.",
      dataIndex: "key", width: 60,
      rowScope: "row",
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      sortable: true,
    },
    {
      title: "Middle Name",
      dataIndex: "middle_name",
      key: "middle_name",
      sortable: true,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      sortable: true,
    },
    {
      title: "First Login",
      dataIndex: "hasLoggedIn",
      key: "hasLoggedIn",
      render: renderStatus(["none"], ["yes"], ["no", "not yet"]),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sortable: true,
    },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (_, record) =>
        activeStatusRenderer(record?.is_active ? "active" : "inactive"),
    },
  ];

  const formFields = [
    {
      label: "Employee Id",
      name: "id",
      hidden: true,
    },
    {
      label: "First Name",
      name: "first_name",
      rules: [{ required: true, message: "First Name is required" }],
    },
    {
      label: "Middle Name",
      name: "middle_name",
    },
    {
      label: "Last Name",
      name: "last_name",
      rules: [{ required: true, message: "Last Name is required" }],
    },
    {
      label: "Department",
      name: "department",
    },
    {
      label: "Employment End Date",
      name: "employment_end_date",
      hidden: true,
    },
    {
      label: "Active",
      name: "is_active",
      type: "switch",
    },
    {
      label: "Positions",
      name: "positions",
      type: "group",
      groupName: "positions",
      objectName: "position_name",
      objectKey: "position_id",
    },
    {
      label: "Email",
      name: "email",
      disabledEdit: true,
    },
  ];

  const pageLoading = employeeLoading || positionLoading;
  const submitLoading = editEmployeeLoading;

  return (
    <>
      {pageLoading && <PivotLoading />}
      {!pageLoading && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1>Inactive Employees</h1>
            <Search
              placeholder="Search name and email..."
              value={searchValue}
              size="large"
              allowClear
              enterButton
              onSearch={handleSearch}
              onChange={(e) => {
                const val = e.target.value;
                setSearchValue(val);
                if (val === "") {
                  handleRefresh("");
                }
              }}
              style={{ marginBottom: 12, maxWidth: 500 }}
            />
          </div>

          <AdminTable
            tableColumn={columns}
            tableData={mappedEmpData}
            tableType="adminEmployee"
            responseData={adminEmpData}
            popupSlice={adminAddInactiveEmp}
            popupName="adminAddInactiveEmp"
            docuType="Employee"
            formFields={formFields}
            onRefresh={() => handleRefresh(searchValue)}
            onEdit={editEmployee}
            submitLoading={submitLoading}
            isEmployee={true}
            positionData={mappedPosData}
            hideAdd={true}
          />
        </>
      )}
    </>
  );
};

export default InactiveEmployees;
